module.exports = __webpack_public_path__ + "img/vip-pic1.79dc59fa.png";